import { Component } from 'react'
import zxcvbn from 'zxcvbn'

export class PasswordStrengthMeter extends Component {
  state = { password: '' }
  inputListener = (e) => this.setState({ password: e.target.value })

  componentDidMount() {
    this.input.addEventListener('input', this.inputListener)
  }

  componentWillUnmount() {
    this.input.removeEventListener('input', this.inputListener)
  }

  get input() {
    return document.getElementById(this.props.inputId)
  }

  createPasswordLabel = (result) => {
    let captions = ['Password too short', 'Weak password', 'Fair password', 'Good password', 'Strong password']
    if (I18n.locale === 'de') captions = ['Passwort zu kurz', 'Schwaches Passwort', 'Mäßiges Passwort', 'Gutes Passwort', 'Starkes Passwort']
    return captions[result.score]
  }


  render() {
    const { password } = this.state
      // To do: Maybe use debounce
    const testedResult = zxcvbn(password)
    if (password.length < 8) { testedResult.score = 0 }
    if (!password) return null
    return <>
      <progress
        className={`password-strength-meter-progress strength-${testedResult.score + 1}`}
        value={testedResult.score + 1}
        max="5"
      />
      <p className="password-strength-meter-label">
        { this.createPasswordLabel(testedResult) }
      </p>
    </>
  }
}
